
export enum MergeTemplateType {
    DividendResolution = 1,
}